import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {onMounted} from "vue";
import router from "@/router";
import jwt_decode from "jwt-decode";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import {useGlobalStore} from "@/stores/GlobalStore";
import {UserService} from "@/utilities/services/entities/UserService";
import OAuthService from "@/utilities/services/OAuthService";
import {User} from "oidc-client";
import {$t} from "@/utilities/i18n/config";
import {notify} from "@kyvg/vue3-notification";
import {disdiClientConfig} from "@/AppConfig";


export default /*@__PURE__*/_defineComponent({
  __name: 'OAuthDisdiCallback',
  setup(__props) {

const globalStore = useGlobalStore();
const userService = new UserService();

onMounted(async ()=> {
  const oAuthService = new OAuthService(globalStore.getAuthorityUrl(), disdiClientConfig.clientId, disdiClientConfig.scopes, disdiClientConfig.callback, disdiClientConfig.silent);
  const userManager = oAuthService.userManager;

  let oAuthUser = null as unknown as User;
  try{
    oAuthUser = await userManager.signinRedirectCallback() as User;
  }
  catch (e) {
    console.error(e);
    return;
  }


  globalStore.setToken(oAuthUser.access_token);

  //@ts-expect-error
  const userResp = await userService.getDisdiUserById(jwt_decode(oAuthUser.access_token).sub);

  if (userResp === null || userResp === undefined || userResp.statusCode !== 0) {
    ErrorHandler.handleError(userResp, ErrorLocationType.login);
  }

  globalStore.setUser(userResp.userInfo);

  //@ts-expect-error
  await router.push(globalStore.oAuth.routeAfterLogin);

  notify({
    title: "Erfolg",
    text: $t('login.notifySuccessfulLogin'),
    duration: 5000,
    type: "success"
  });
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, " Waiting "))
}
}

})